import { Link } from "react-router-dom"
import ServiceRequestForm from "../components/ServiceRequestForm"
import "./ServiceRequestPage.css"

function ServiceRequestPage() {
  return (
    <div className="prescription-page">
      <Link to="/" className="back-link">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M19 12H5M12 19l-7-7 7-7" />
        </svg>
        Back to Home
      </Link>

      <div className="page-header">
        <h1>Request a Pharmacy Service</h1>
        <p>
          Book an appointment for one of our pharmacy services.
        </p>
      </div>

      <div className="form-container">
        <ServiceRequestForm />
      </div>

      <div className="info-box">
        <h2>Our Services</h2>
        <ul>
          <li><strong>Pharmacy First (NHS):</strong> Free NHS treatment for 7 common conditions without a GP appointment.</li>
          <li><strong>Weight Loss Service:</strong> Personalised weight management with Mounjaro and Wegovy.</li>
          <li><strong>New Medicine Service:</strong> Free support when starting a new medicine for a long-term condition.</li>
          <li><strong>Contraception:</strong> Convenient access to contraceptive services and advice.</li>
          <li><strong>Flu Vaccination:</strong> Protect yourself and others with a flu jab.</li>
          <li><strong>Private Prescriptions:</strong> Quick and convenient private prescription services.</li>
          <li><strong>Hypertension Case Finding:</strong> Free NHS blood pressure checks for adults 40+.</li>
          <li>For any questions, please contact our pharmacy team at 01772 865238.</li>
        </ul>
      </div>
    </div>
  )
}

export default ServiceRequestPage
